import { render, staticRenderFns } from "./RssBlogItem.vue?vue&type=template&id=922bc41c&scoped=true&"
import script from "./RssBlogItem.vue?vue&type=script&lang=js&"
export * from "./RssBlogItem.vue?vue&type=script&lang=js&"
import style0 from "./RssBlogItem.vue?vue&type=style&index=0&id=922bc41c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922bc41c",
  null
  
)

export default component.exports